import React ,{ useEffect, useState } from "react";
import "./androidGames.css";
import Heading from "../Heading/Heading";
import AndroidItem from "../AndroidItem/AndroidItem";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { notify1 } from "../../Components/ToastComponent";
import ReactiveSubscriptionModal from "../../Components/ReactiveSubscription/ReactiveSubscription";
import NoBalanceModal from "../../Components/NoBalanceModal/NoBalanceModal";
import { Link, useNavigate } from "react-router-dom";

const AndroidGames = ({ androidGames }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const canPlay = JSON.parse(localStorage.getItem("can_play"));
  const hostName =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("libyad") || window.location.hostname.includes("gamerclub.ly");
  const [showSubModal, setShowSubModal] = useState(false);
  const [showNoBalanceModal, setShowNoBalanceModal] = useState(false);

  const openReactiveSubscriptionModal = () => setShowSubModal(true);
  const closeReactiveSubscriptionModal = () => setShowSubModal(false);
  const openNoBalanceModal = () => setShowNoBalanceModal(true);
  const closeNoBalanceModal = () => setShowNoBalanceModal(false);

  const handlePlayClick = (gameId) => {
    if (!token) {
      notify1("Please Sign in first");
      return;
    }
    if (!canPlay && hostName) {
      const blockReason = localStorage.getItem("subscription_block_reason");
      if (blockReason === "no_balance") {
        openNoBalanceModal();
      } else {
        openReactiveSubscriptionModal();
      }
    } else {
      navigate(`/play/${gameId}`);
    }
  };
  return (
    <div className="android_games">
      <Container fluid>
        <div className="battles-section">
          <Heading
            title={t("android games")}
            btn_title={t("see all")}
            headingNavigate={"/android"}
          />
          <hr />
          <div className="battles-games">
            <Row>
              {androidGames &&
                androidGames.map((android) => (
                  <Col xs={6} md={3} lg={3} xl={2} key={android.id}>
                    <AndroidItem
                      android_img={android.thumb}
                      android_btn={t("download now")}
                      gameItemId={android.id}
                      imgNavigate={"androidGameDetails"}
                      btnNavigate={"androidGameDetails"}
                        onPlayClick={handlePlayClick}

                    />
                  </Col>
                ))}
            </Row>
          </div>
        </div>
      </Container>
       <ReactiveSubscriptionModal
  show={showSubModal}
  onClose={closeReactiveSubscriptionModal}
/>
      <NoBalanceModal show={showNoBalanceModal} onClose={closeNoBalanceModal} />
    </div>
  );
};

export default AndroidGames;
